import Crud from '../components/UserActivity/Crud'

let routes = {
    path: '/user_activities',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/user_activities',
            name: 'Atividades de Usuários',
            component: Crud,
            meta: { requiresAdmin: true }
        },
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/userActivity.js